import React, { useState, useEffect } from 'react';
import { InProgressTournaments } from '../../features/tournaments/components/inProgressTournaments/inProgressTournaments';
import { PendingTournaments } from '../../features/tournaments/components/pendingTournaments/pendingTournaments';
import { FinishedTournaments } from '../../features/tournaments/components/finishedTournaments/finishedTournaments';
import TournamentsAdditionalInfo from '../../features/tournaments/components/tournamentsAdditionalInfo/tournamentsAdditionalInfo';
import { container } from 'tsyringe';
import { AdditionalType } from '../../features/tournaments/model/interfaces';
import { TournamentsService } from '@base/features/tournaments/model/interfaces';
import { Tourney } from '../../features/tournaments/model/interfaces';
import { TournamentsHeader } from '../../features/tournaments/components/tournamentsHeader/tournamentsHeader';
import { Loader } from '@ui-kit/components/loader';
import { isResponseError } from '../../features/auth/utils/typequards';

export type Tournaments = {
  ['started']: Tourney[];
  ['pending']: Tourney[];
  ['finished']: Tourney[];
};

function TournamentsPage() {
  const tournamentsService: TournamentsService =
    container.resolve('tournamentsService');
  const [tournaments, setTournaments] = useState<Tournaments | null>(null);
  const [activeItem, setActiveItem] = useState('');
  const [additionalComponent, setAdditionalComponent] =
    useState<AdditionalType>();

  useEffect(() => {
    tournamentsService.getTournamentsListForGameId().then((response) => {
      if (!isResponseError(response)) {
        setTournaments({
          started: response['S'],
          pending: response['P'],
          finished: response['F'],
        });
      }
    });

    const fetchData = setInterval(() => {
      tournamentsService.getTournamentsListForGameId().then((response) => {
        if (!isResponseError(response)) {
          setTournaments({
            started: response['S'],
            pending: response['P'],
            finished: response['F'],
          });
        }
      });
    }, 5000);
    return () => clearInterval(fetchData);
  }, [tournamentsService]);

  if (!tournaments) return <Loader className="loader-container--black" />

  return (
    <div className="tournaments">
      <TournamentsHeader />
      <main className="tournaments-main">
        <article className="tournaments__lists">
          {tournaments && !!tournaments.started.length && (
            <div className="tournaments__lists-item tournaments__in-progress">
              <InProgressTournaments
                tournaments={tournaments}
                setComponent={setAdditionalComponent}
              />
            </div>
          )}
          {tournaments && !!tournaments.pending.length && (
            <div className="tournaments__lists-item tournaments__pending">
              <PendingTournaments
                tournaments={tournaments}
                setComponent={setAdditionalComponent}
                activeItem={activeItem}
                setActiveItem={setActiveItem}
              />
            </div>
          )}
          <div className="tournaments__lists-item tournaments__finished">
            <FinishedTournaments
              tournaments={tournaments}
              setComponent={setAdditionalComponent}
              activeItem={activeItem}
              setActiveItem={setActiveItem}
            />
          </div>
        </article>
        {additionalComponent?.component && (
          <aside className="tournaments__additional-info">
            <TournamentsAdditionalInfo addData={additionalComponent} tournament={tournaments.pending.find(t => t.TourneyID === activeItem)}/>
          </aside>
        )}
      </main>
    </div>
  );
}

export default TournamentsPage;
